import styles from 'styles/pages/professor/StudentDetail.module.scss';
import { TStudentDetailInfoResponse } from 'types/apis/professor';
import { telFormatter } from 'utils/tel';

type TProps = {
  data?: TStudentDetailInfoResponse | undefined;
};

const StudentInfo = ({ data }: TProps) => {
  return (
    <div className={styles.info_card_wrapper}>
      <div className={styles.info_card}>
        <p className={styles.info_title}>학생 기본 정보</p>
        <div className={styles.info_items}>
          <dl>
            <dt>이름</dt>
            <dd>{data?.studentName || '-'}</dd>
          </dl>
          <dl>
            <dt>학번</dt>
            <dd>{data?.loginId || '-'}</dd>
          </dl>
          <dl>
            <dt>연락처</dt>
            <dd>{telFormatter(data?.phoneNum || '-')}</dd>
          </dl>
          <dl>
            <dt>강의</dt>
            <dd>{data?.courseName || '-'}</dd>
          </dl>
          <dl>
            <dt>분반</dt>
            <dd>{data?.studClass || '-'}</dd>
          </dl>
        </div>
      </div>
    </div>
  );
};

export default StudentInfo;
